import Vue from "vue";
import { User } from "@/shared/types/users";
import { getUsers } from "@lab/api/users.api";

const state = {
	byID: [],
	isFetching: false,
	errorMessage: null,
	lastFetched: null // Timestamp
};

const getters = {
	getUsers: (state): User[] =>
		state.byID ? Object.values(state.byID) : null,
	getUser:
		(state: any) =>
		(id: number): User => {
			return state.byID[id];
		},
	IsFetching: (state): boolean => state.isFetching,
	error: (state): string => state.errorMessage
};

const actions = {
	async fetchUsers({ commit }) {
		try {
			commit("LOAD_START");
			const response = await getUsers();
			commit("LOAD_LIST_SUCCESS", response);
		} catch (error) {
			// handle the error here
		}
	}
};

const mutations = {
	LOAD_LIST_SUCCESS(state: any, users: User[]) {
		const byID = users.reduce((acc, val) => {
			acc[val.id] = val;
			return acc;
		}, {});
		Vue.set(state, "byID", byID);
		state.lastFetched = Date.now();
		state.isFetching = false;
	},
	LOAD_ITEM_SUCCESS(state: any, user: User) {
		if (!user) return;
		Vue.set(state.byID, user.id.toString(), user);
		state.isFetching = false;
	},
	UPDATE_ITEM_SUCCESS(state: any, user: User) {
		const { id } = user;
		const updated = { ...state.byID[id], ...user };
		Vue.set(state.byID, user.id, updated);
	},
	LOAD_START(state: any) {
		state.errorMessage = null;
		state.isFetching = true;
	}
};

export default { namespaced: true, state, getters, actions, mutations };
